import { HttpService } from './http.service'
import { apiRoutes } from '../routing/api-routes'
import { ProductFeaturesResponse } from '../types/product-feature'

export const ProductService = {
  async getProductFeatures(): Promise<ProductFeaturesResponse> {
    return HttpService.get(apiRoutes.productFeatures)
  },
}
